import React from 'react'
import MeetContact from '../Component/Contact/MeetContact'
import AboutContact from '../Component/Contact/AboutContact'
import ContactUs from '../Component/Service/ContactUs'
import ContactHead from '../Component/Contact/ContactHead'

const Contact = () => {
  return (
    <>
    <ContactHead />
    <AboutContact />
    <MeetContact />
    <ContactUs />
    </>
  )
}

export default Contact